import { render, staticRenderFns } from "./porpagar.vue?vue&type=template&id=00e7cf28"
import script from "./porpagar.vue?vue&type=script&lang=js"
export * from "./porpagar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports